import { useSelector, useDispatch } from 'react-redux'
import { PanelControls } from 'apps/studio/components/shared/PanelControls'
import { AddLibrary } from 'apps/studio/components/leftPanel/AddLibrary'
import { FormOutline } from 'apps/studio/components/leftPanel/FormOutline'
import { PdfOutline } from 'apps/studio/components/leftPanel/PdfOutline'
import {
  activeModeSelector,
  activeLeftPanelsSelector,
  plgDemoSelector,
} from 'apps/studio/store/selectors/studioSettings'
import {
  LEFT_PANELS,
  studioSettingsActions,
  PDF_MODE,
} from 'apps/studio/store/reducers/settings/studioSettings'
const { toggleLeftPanel } = studioSettingsActions
import { AddIcon, MobileIcon, PageIcon } from '@gocanvas/gcds/icons'

const leftPanelIcons = {
  Add: AddIcon,
  'Form Outline': MobileIcon,
  'PDF Outline': PageIcon,
}

const leftPanelComponents = {
  Add: AddLibrary,
  'Form Outline': FormOutline,
  'PDF Outline': PdfOutline,
}

export const LeftPanels = () => {
  const dispatch = useDispatch()
  const showWorkspacePanels = useSelector(activeModeSelector) === PDF_MODE
  const activeLeftPanels = useSelector(activeLeftPanelsSelector)
  const plgDemo = useSelector(plgDemoSelector)

  const visiblePanels = plgDemo
    ? LEFT_PANELS.filter(p => p !== 'PDF Outline')
    : LEFT_PANELS

  const leftPanelControls = visiblePanels.map(panelName => ({
    active: activeLeftPanels.includes(panelName),
    type: panelName,
    icon: leftPanelIcons[panelName],
  }))

  const togglePanel = panelName =>
    dispatch(toggleLeftPanel({ panel: panelName }))

  return (
    <>
      <PanelControls
        side="left"
        togglePanelAction={togglePanel}
        showPanelControls={showWorkspacePanels}
        controls={leftPanelControls}
      />
      <div className="left-panel">
        {showWorkspacePanels &&
          activeLeftPanels.filter(p => !plgDemo || p !== 'PDF Outline').map(panelName => {
            const PanelComponent = leftPanelComponents[panelName]
            return <PanelComponent key={`${panelName}-panel`} />
          })}
      </div>
    </>
  )
}
